import { Injectable, NgZone } from '@angular/core';
import { AuthService } from './auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class IdleService {
  private idleTime = 0;
  private readonly MAX_IDLE_TIME = 20 * 60;  
  private intervalId: any;
  private isFocused = true;

  constructor(private authService: AuthService, private ngZone: NgZone) {}

  startWatching() {
    this.resetTimer();

    window.addEventListener('focus', () => {
      this.isFocused = true;
      this.resetTimer();
    });

    window.addEventListener('blur', () => {
      this.isFocused = false;
    });

    this.ngZone.runOutsideAngular(() => {
      this.intervalId = setInterval(() => {
        if (!this.isFocused) {
          this.idleTime++;
          if (this.idleTime >= this.MAX_IDLE_TIME) {
            this.ngZone.run(() => this.authService.logout());
          }
        } else {
          this.resetTimer();
        }
      }, 1000);
    });

    this.addActivityListeners();
  }

  resetTimer() {
    this.idleTime = 0;
  }

  stopWatching() {
    clearInterval(this.intervalId);
    this.removeActivityListeners();
  }

  private addActivityListeners() {
    const events = ['mousemove', 'mousedown', 'click', 'keydown', 'scroll'];
    events.forEach(event =>
      window.addEventListener(event, this.resetTimer.bind(this))
    );
  }

  private removeActivityListeners() {
    const events = ['mousemove', 'mousedown', 'click', 'keydown', 'scroll'];
    events.forEach(event =>
      window.removeEventListener(event, this.resetTimer.bind(this))
    );
  }
}
